__turbopack_context__.v({
  "categoryCheckbox": "styles-module__NicdIG__categoryCheckbox",
  "categoryFilterDropdownContents": "styles-module__NicdIG__categoryFilterDropdownContents",
  "subcategoryCheckbox": "styles-module__NicdIG__subcategoryCheckbox",
});
